/**
 * iOS WKWebView ichida host bridge ba'zi signal larni (Telegram initData,
 * Click `web-session` cookie va h.k.) kechikib inject qiladi. Bu yerda
 * shu signal larni kutish uchun yagona polling helper joylashgan —
 * Telegram va Click adapterlari ham, kelajakdagilar ham shuni ishlatadi.
 */

const DEFAULT_TIMEOUT_MS = 4000;
const POLL_INTERVAL_MS = 50;

/**
 * `read` truthy qiymat qaytarguncha (yoki timeout tugaguncha) `POLL_INTERVAL_MS` da
 * bir marta polling qiladi. Birinchi sync tekshirishda topilsa darhol qaytadi (0ms).
 * Promise hech qachon reject bo'lmaydi — timeout da `null` qaytadi va chaqiruvchi
 * o'zi qaror qabul qiladi.
 */
export function pollFor<T>(
  read: () => T | null | undefined,
  timeoutMs: number = DEFAULT_TIMEOUT_MS
): Promise<T | null> {
  const immediate = read();
  if (immediate) return Promise.resolve(immediate);

  return new Promise((resolve) => {
    const deadline = Date.now() + timeoutMs;
    const tick = () => {
      const value = read();
      if (value) {
        resolve(value);
        return;
      }
      if (Date.now() >= deadline) {
        resolve(null);
        return;
      }
      setTimeout(tick, POLL_INTERVAL_MS);
    };
    setTimeout(tick, POLL_INTERVAL_MS);
  });
}
